import { Save } from '@mui/icons-material';
import './scss/restaurant-extensions.scss';
import i18n from '../../../i18n';
import DialogComponent from '../../../component/dialog/dialog.component';
import ButtonComponent from '../../../component/button/button.component';
import CardFrom, { CardFormConfig } from '../../../component/card/card-from';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { ResellerGYBDialogState } from './restaurant-reseller-gyb-state';
import { INTERMEDIARY } from '../../../constants/base.contants';
import React from 'react';
import { GybDevice, GybThirdParty, Restaurant } from '../../../models';
import { Grid, Skeleton } from '@mui/material';
import CardView from '../../../component/card/card-view';

export const ResellerGYBDialogCardConfig: () => CardFormConfig[] = () => [

    // 餐厅税务信息
    {
        key: 'tax',
        title: i18n.t('restaurant_info_page_text_restaurant_tax_information'),
        rowSpacing: 6,
        children: [
            {
                key: 'reg_vat_number',
                label: i18n.t('restaurant_info_page_text_vat_number'),
                inputType: 'INPUT',
                comType: 'INPUT',
                regularType: 'vatNumber',
                required: true,
                xs: 12,
                disabledInput: true
            },
            {
                key: 'reg_fiscal_code',
                label: i18n.t('restaurant_info_page_text_fiscal_code'),
                inputType: 'INPUT',
                comType: 'INPUT',
                regularType: 'fiscalCode',
                required: true,
                xs: 12,
                disabledInput: true
            },
            {
                key: 'description',
                label: i18n.t('gyb_page_text_describe'),
                inputType: 'INPUT',
                comType: 'INPUT',
                regularType: 'name',
                required: true,
                xs: 12,
                disabledInput: true
            },
            {
                key: 'email',
                label: i18n.t('general_text_email'),
                inputType: 'INPUT',
                comType: 'INPUT',
                regularType: 'email',
                required: true,
                xs: 12,
                disabledInput: true
            },
        ]
    },
    // 餐厅税务地址
    {
        key: 'taxAddress',
        title: i18n.t('restaurant_info_page_text_restaurant_tax_address'),
        rowSpacing: 6,
        columnSpacing: { md: 4, xs: 4 },
        children: [
            {
                key: 'reg_local',
                label: i18n.t('address_component_text_address'),
                inputType: 'INPUT',
                comType: 'INPUT',
                xs: 12,
                md: 12,
                required: true,
                regularType: 'required',
                disabledInput: true
            },
            {
                key: 'reg_postcode',
                label: i18n.t('restaurant_info_page_text_postcode'),
                inputType: 'INPUT',
                comType: 'INPUT',
                xs: 6,
                md: 6,
                required: true,
                regularType: 'required',
                disabledInput: true

            },
            {
                key: 'reg_city',
                label: i18n.t('restaurant_info_page_text_city'),
                inputType: 'INPUT',
                comType: 'INPUT',
                xs: 6,
                md: 6,
                required: true,
                regularType: 'required',
                disabledInput: true

            },
            {
                key: 'reg_state',
                label: i18n.t('restaurant_info_page_text_state'),
                inputType: 'INPUT',
                comType: 'INPUT',
                xs: 6,
                md: 6,
                required: true,
                regularType: 'required',
                disabledInput: true

            },
            {
                key: 'reg_country',
                label: i18n.t('restaurant_info_page_text_country'),
                inputType: 'INPUT',
                comType: 'INPUT',
                xs: 6,
                md: 6,
                required: true,
                regularType: 'required',
                disabledInput: true
            },
        ]
    },
    // 基础信息
    {
        key: 'baseInfo',
        title: i18n.t('gyb_page_text_basic_information'),
        md: 12,
        rowSpacing: 6,
        columnSpacing: { md: 4, xs: 4 },
        children: [
            {
                key: 'locationId',
                label: i18n.t('gyb_page_text_registered_id'),
                inputType: 'INPUT',
                comType: 'INPUT',
                // required: true,
                xs: 6,
                md: 6,
            },
            {
                key: 'brand',
                label: `${i18n.t('gyb_page_text_brand')}${i18n.t('restaurant_page_input_text_customize')}`,
                inputType: 'INPUT',
                comType: 'INPUT',
                required: true,
                regularType: 'required',
                xs: 6,
                md: 6,
            },
            {
                key: 'deviceCode',
                label: `${i18n.t('gyb_page_text_the_device_number')}${i18n.t('restaurant_page_input_text_customize_and_not_repeatable')}`,
                inputType: 'INPUT',
                comType: 'INPUT',
                required: true,
                regularType: 'required',
                xs: 6,
                md: 6,
            },
            {
                key: 'model',
                label: `${i18n.t('gyb_page_text_model')}${i18n.t('restaurant_page_input_text_customize')}`,
                inputType: 'INPUT',
                comType: 'INPUT',
                required: true,
                regularType: 'required',
                xs: 6,
                md: 6,
            }, {
                key: 'licenseCode',
                label: `${i18n.t('gyb_page_text_GYB_key')}${i18n.t('restaurant_page_input_text_not_repeatable')}`,
                inputType: 'INPUT',
                comType: 'INPUT',
                required: true,
                regularType: 'required',
                xs: 6,
                md: 6,
            },
            {
                key: 'intermediaryType',
                label: i18n.t('gyb_page_text_valore_significato'),
                inputType: 'SELECT',
                comType: 'INPUT',
                required: true,
                regularType: 'required',
                xs: 6,
                md: 6,
            }, {
                key: 'name',
                label: i18n.t('gyb_page_text_restaurant_name'),
                inputType: 'INPUT',
                comType: 'INPUT',
                xs: 6,
                md: 6,
                required: true,
                regularType: 'required',
            },
            {
                key: 'local',
                label: `${i18n.t('gyb_page_text_restaurant_address')}`,
                inputType: 'INPUT',
                comType: 'INPUT',
                xs: 6,
                md: 6,
                required: true,
                regularType: 'required',
            },
        ]
    },
    // 密钥
    {
        key: 'gyb_key',
        title: i18n.t('gyb_page_text_GYB_management_information'),
        md: 12,
        xs: 12,
        children: [
            {
                key: 'gyb_key_list',
                comType: 'TABLE',
                xs: 12,
            },
        ]
    },
]
/**
 * 经销商GYB弹窗
 */
export default observer(function ResellerGYBDialog(props: {
    open: boolean;
    onClose: () => void;
    onSaveCallback: (error: boolean) => void;
    dialogType: 'ADD' | 'PREVIEW';
    restaurantInfo: Restaurant;
    GYBList: GybDevice[];
    GYBDeviceInfo?: GybDevice;
}) {
    const useData = useLocalObservable(() => new ResellerGYBDialogState());
    React.useEffect(() => {
        if (props.open === true) {
            (async () => {
                useData.updateIsLoading(true);
                useData.updateDialogType(props.dialogType)
                useData.updateRestaurantInfo(props.restaurantInfo);
                useData.updateGYBList(props.GYBList);
                useData.updateGYBDeviceInfo(props.GYBDeviceInfo);

                await useData.init();
                useData.updateIsLoading(false);
            })()
        }
        return () => {
            useData.clearGybFormInfo();
        }
    }, [props.open])

    const cardConfig: CardFormConfig[] = ResellerGYBDialogCardConfig().map((item) => {
        const extraParentConfig = {};
        switch (item.key) {
            case 'baseInfo':
                // extraParentConfig = {
                //     title: <>{i18n.t('gyb_page_text_basic_information')}
                //         <ButtonComponent
                //             variant='text'
                //             color='secondary'
                //             titleText={`${i18n.t('gyb_page_text_gyb_key_application')}`}
                //             handleClick={() => {
                //                 window.open('#/help-center');
                //             }} >
                //             <HelpOutline />
                //         </ButtonComponent>
                //     </>
                // }
                break;
            default:
                break;
        }

        return {
            ...item,
            ...extraParentConfig,
            children: item?.children?.map((childrenItem) => {
                let extraConfig = {};
                const hasGYBDevice = useData.GYBList?.length > 0;
                switch (childrenItem.key) {
                    case 'reg_vat_number':
                    case 'reg_fiscal_code':
                    case 'description':
                    case 'email':
                    case 'reg_local':
                    case 'reg_postcode':
                    case 'reg_city':
                    case 'reg_state':
                    case 'reg_country':
                    case 'name':
                    case 'local':
                        extraConfig = {
                            // 编辑过后输入框底色反馈
                            inputIsEdited: useData.operateMap.get(childrenItem.key) !== undefined ? true : false,
                            disabledInput: hasGYBDevice || props.dialogType === 'PREVIEW'
                        }
                        break;
                    case 'brand':
                    case 'deviceCode':
                    case 'model':
                    case 'licenseCode':
                        extraConfig = {
                            // 编辑过后输入框底色反馈
                            inputIsEdited: useData.operateMap.get(childrenItem.key) !== undefined ? true : false,
                            disabledInput: props.dialogType === 'PREVIEW'
                        }
                        break;
                    case 'locationId':
                        extraConfig = {
                            // 有才显示注册ID，且之后添加的设备用同个设备ID
                            hidden: !hasGYBDevice,
                            required: hasGYBDevice,
                            disabledInput: props.dialogType === 'PREVIEW',
                            inputIsEdited: useData.operateMap.get('locationId') !== undefined ? true : false,
                        }
                        break;
                    case 'intermediaryType':
                        extraConfig = {
                            items: INTERMEDIARY,
                            inputIsEdited: useData.operateMap.get('intermediaryType') !== undefined ? true : false,
                            disabledInput: hasGYBDevice || props.dialogType === 'PREVIEW'
                        }
                        break;
                    case 'gyb_key_list':
                        extraConfig = {
                            tableConfig: {
                                showChecked: props.dialogType === 'PREVIEW' ? 0 : 1,
                                headCellList: [
                                    { id: 'name', label: i18n.t('gyb_page_text_the_key_name'), sortStatus: -1 },
                                    { id: 'username', label: i18n.t('gyb_page_text_name'), sortStatus: -1 },
                                ],
                                list: useData?.thirdPartyReseller || [],
                                handleCheck: (GybThirdParty: GybThirdParty[]) => {
                                    const dealer = GybThirdParty?.length > 0 ? GybThirdParty?.[0]?._id || '' : '';
                                    useData.updateGYBData(dealer, 'dealer');
                                },
                                selectType: 'RADIO',
                            }
                        }
                        break;

                    default:
                        extraConfig = {
                            disabledInput: hasGYBDevice || props.dialogType === 'PREVIEW'
                        }
                        break;
                }
                // 允许空校验
                const allowNullVerification = useData.allowNullVerification
                return {
                    ...childrenItem,
                    ...extraConfig,
                    isEmpty: allowNullVerification,
                    onChange: (e) => {
                        return useData.updateGYBData(e.target.value, childrenItem.key);
                    }
                }

            })
        }
    }) as CardFormConfig[];


    return (
        <DialogComponent
            open={props.open}
            fullWidth={true}
            heightSize={'large'}
            onClose={() => {
                props.onClose();
            }}
            defaultHeaderProps={
                {
                    title: i18n.t('gyb_setting_page_text_gyb_device'),
                    rightNode: props.dialogType === 'ADD' ? <ButtonComponent
                        variant='outlined'
                        handleClick={async () => {
                            await useData.onSave(props.onSaveCallback);
                        }}
                        titleText={i18n.t('general_text_save')}
                    >
                        <Save className='iconColor' />
                    </ButtonComponent> : undefined
                }
            }
        >
            {useData.isLoading ? <SkeletonOfGYB />
                : <CardFrom
                    config={cardConfig}
                    data={useData.editGYBData as {}}
                />
            }

        </DialogComponent >
    )
})

/**
 * 骨架屏 - GYB
 */
const SkeletonOfGYB = () => {
    return (
        <div className='skeleton'>
            <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                    <CardView
                        style={{ height: '100%' }}
                        contentRender={(
                            <Grid container rowSpacing={4}>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' width={90} height={25} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                            </Grid>
                        )}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <CardView
                        style={{ height: '100%' }}
                        contentRender={(
                            <Grid container rowSpacing={4}>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' width={90} height={25} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                            </Grid>
                        )}
                    />
                </Grid>
                <Grid item xs={12}  >
                    <CardView
                        style={{ height: '100%' }}
                        contentRender={(
                            <Grid container rowSpacing={4} columnSpacing={4}>
                                <Grid container item rowSpacing={4} xs={6}>
                                    <Grid item xs={12}>
                                        <Skeleton variant='rounded' width={90} height={25} animation='wave' />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Skeleton variant='rounded' height={30} animation='wave' />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Skeleton variant='rounded' height={30} animation='wave' />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Skeleton variant='rounded' height={30} animation='wave' />
                                    </Grid>
                                </Grid>
                                <Grid container item rowSpacing={4} xs={6}>
                                    <Grid item xs={12}>
                                        <Skeleton variant='rounded' width={90} height={25} animation='wave' />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Skeleton variant='rounded' height={30} animation='wave' />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Skeleton variant='rounded' height={30} animation='wave' />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Skeleton variant='rounded' height={30} animation='wave' />
                                    </Grid>
                                </Grid>
                            </Grid>
                        )}
                    />
                </Grid>
                <Grid item xs={12}>
                    <CardView
                        style={{ height: '100%' }}
                        contentRender={(
                            <Grid container rowSpacing={4}>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' width={90} height={25} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={170} animation='wave' />
                                </Grid>
                            </Grid>
                        )}
                    />
                </Grid>
            </Grid>
        </div>
    )
}